import { render } from "./initPage.vue?vue&type=template&id=12ea934c&scoped=true"
import script from "./initPage.vue?vue&type=script&lang=js"
export * from "./initPage.vue?vue&type=script&lang=js"

import "./initPage.vue?vue&type=style&index=0&id=12ea934c&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ea934c"]])

export default __exports__